import React, { useEffect, useState } from "react";
import "./DoEarn.css";
import earn from "../../assets/images/earn-txt.png";
import gift from "../../assets/images/gift.svg";
import twitter from "../../assets/images/twitter.svg";
import logo from "../../assets/images/meme-logo.svg";
import youtube from "../../assets/images/youtube.svg";
import telegram from "../../assets/images/telegram.svg";
import dobottom from "../../assets/images/stuff.gif";
import {
  cheapStuff,
  EarlyRewardClaim,
  getUserDetails1,
  GeneratePromoCode,
} from "../../apis/user";
import useUserInfo from "../../Hooks/useUserInfo";
import cancelIcon from "../../assets/Task/cancelicon.svg";
import Tv from "../Tv/Tv";
import { useAudio } from "../../Providers/AudioProvider";
import { logPageView } from "../../components/analytics";
import { Timer } from "lucide-react";
import PromoHistory from "./PromoHistory";
const DoEarn = () => {
  const { watchScreen, userDetails, updateUserInfo, updatewatchScreenInfo } =
    useUserInfo();
  const userId = userDetails?.userDetails?.telegramId;

  const [tOffchannel, settOffchannel] = useState(
    localStorage.getItem(`tOffchannel_${userId}`)
  );
  const [tOffChannelvalid, setTOffChannelvalid] = useState(false);

  const [xchannel, setXchannel] = useState(
    localStorage.getItem(`xchannel_${userId}`)
  );
  const [xchannelvalid, setXchannelValid] = useState(false);

  const [ychannel, setYchannel] = useState(
    localStorage.getItem(`ychannel_${userId}`)
  );
  const [ychannelvalid, setYchannelValid] = useState(false);

  const [tchannel, setTchannel] = useState(
    localStorage.getItem(`tchannel_${userId}`)
  );
  const [tchannelvalid, setTchannelValid] = useState(false);

  const [isHelpVisible, setIsHelpVisible] = useState(false);
  const playClick = useAudio();

  const toggleHelp = (e) => {
    playClick();
    e.preventDefault();
    setIsHelpVisible(!isHelpVisible);
  };

  const joinXChannel = () => {
    playClick();
    localStorage.setItem(`xchannel_${userId}`, new Date());
    setXchannel(new Date());
    window.open("https://x.com/thememe_tv", "_blank");
  };

  const joinYChannel = () => {
    playClick();
    localStorage.setItem(`ychannel_${userId}`, new Date());
    setYchannel(new Date());
    window.open("https://instagram.com/thememe_tv", "_blank");
  };

  const joinTChannel = () => {
    playClick();
    localStorage.setItem(`tchannel_${userId}`, new Date());
    setTchannel(new Date());
    window.open("https://t.me/thememetvcommunity", "_blank");
  };
  const joinMemeOffChannel = () => {
    playClick();
    localStorage.setItem(`tOffchannel_${userId}`, new Date());
    settOffchannel(new Date());
    window.open("https://t.me/thememetvofficial", "_blank");
  };

  const [isLoading, setIsLoading] = useState(false); // State for loader visibility

  const claimRewards = async (channel) => {
    // Show loader
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));

    const data = {
      taskPoints: String(5000),
      channel: channel,
    };

    try {
      // Make the API call
      const res = await cheapStuff(data);

      // Update state based on the channel
      if (channel === "twitter") {
        setXchannelValid("claimed");
      }
      if (channel === "youtube") {
        setYchannelValid("claimed");
      }
      if (channel === "telegram") {
        setTchannelValid("claimed");
      }
      if (channel === "telegramCommunity") {
        setTOffChannelvalid("claimed");
      }
    } catch (error) {
      console.error("Error claiming rewards:", error);
    } finally {
      // Hide loader
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
    }
  };
  useEffect(() => {
    logPageView("DoandEarn ", "Do and Earn Page");
  }, []);
  useEffect(() => {
    if (xchannel) {
      const storedDate = new Date(xchannel); // Directly convert the date string to Date object
      const currentDate = new Date();

      // Calculate the difference in minutes
      const timeDifferenceInMinutes = Math.floor(
        (currentDate - storedDate) / (1000 * 60)
      );

      // If more than 30 minutes have passed, update the state
      if (timeDifferenceInMinutes >= 2) {
        setXchannelValid(true);
      } else {
        setXchannelValid(false); // Optional: Reset if within 30 minutes
      }
    }
    if (tOffchannel) {
      const storedDate = new Date(tOffchannel); // Directly convert the date string to Date object
      const currentDate = new Date();

      // Calculate the difference in minutes
      const timeDifferenceInMinutes = Math.floor(
        (currentDate - storedDate) / (1000 * 60)
      );

      // If more than 30 minutes have passed, update the state
      if (timeDifferenceInMinutes >= 2) {
        setTOffChannelvalid(true);
      } else {
        setTOffChannelvalid(false); // Optional: Reset if within 30 minutes
      }
    }
    if (ychannel) {
      const storedDate = new Date(ychannel); // Directly convert the date string to Date object
      const currentDate = new Date();

      // Calculate the difference in minutes
      const timeDifferenceInMinutes = Math.floor(
        (currentDate - storedDate) / (1000 * 60)
      );

      // If more than 30 minutes have passed, update the state
      if (timeDifferenceInMinutes >= 2) {
        setYchannelValid(true);
      } else {
        setYchannelValid(false); // Optional: Reset if within 30 minutes
      }
    }
    if (tchannel) {
      const storedDate = new Date(tchannel); // Directly convert the date string to Date object
      const currentDate = new Date();

      // Calculate the difference in minutes
      const timeDifferenceInMinutes = Math.floor(
        (currentDate - storedDate) / (1000 * 60)
      );

      // If more than 30 minutes have passed, update the state
      if (timeDifferenceInMinutes >= 2) {
        setTchannelValid(true);
      } else {
        setTchannelValid(false); // Optional: Reset if within 30 minutes
      }
    }

    if (userDetails?.userDetails.taskRewards.twitter) {
      setXchannelValid("Isclaimed");
    }
    if (userDetails?.userDetails.taskRewards.telegram) {
      setTchannelValid("Isclaimed");
    }
    if (userDetails?.userDetails.taskRewards.youtube) {
      setYchannelValid("Isclaimed");
    }
    if (userDetails?.userDetails?.taskRewards?.telegramCommunity) {
      setTOffChannelvalid("Isclaimed");
    }
    // if (userDetails?.userDetails.taskRewards.telegram) {
    //   setTOffChannelvalid("claimed");
    // }
  }, []);
  const getUserDetailsOnly = async () => {
    let userDetails1;
    try {
      userDetails1 = await getUserDetails1(
        userDetails?.userDetails?.telegramId
      );
    } catch (error) {
      console.error("Error in updating or fetching user details:", error);
    }
    // Update state after both async calls are completed
    if (userDetails) {
      updateUserInfo((prev) => ({
        ...prev,
        userDetails: userDetails1,
      }));
      updatewatchScreenInfo((prev) => ({
        ...prev,
        boostersList: userDetails1?.boosters,
        totalReward: userDetails1?.balanceRewards,
        tapPoints: 0,
        booster: false,
        boosterSec: 0,
        boosterPoints: 0,
        boosterDetails: {},
        watchSec: 0,
      }));
    }
    return userDetails;
  };
  const goToThePage = (component, name) => {
    updateUserInfo((prev) => {
      return {
        ...prev,
        ...{
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails.currentComponent,
          lastComponentText: userDetails.currentComponentText,
          isMenu: false,
        },
      };
    });
    playClick();
  };
  const toogleMenu = () => {
    playClick();
    if (!watchScreen.booster) {
      const data = getUserDetailsOnly().then(() => {
        updateUserInfo((prev) => ({
          ...prev,
          isPlay: false,
          currentComponent: Tv,
          currentComponentText: "TVPage",
          lastComponent: userDetails?.userDetails.currentComponent,
          lastComponentText: userDetails?.userDetails.currentComponentText,
          isMenu: false,
          menuCount: userDetails?.userDetails?.menuCount + 1,
        }));
        // goToThePage(Battle, "BattlePage");
      });
    } else {
      goToThePage(Tv, "TVPage");
    }
  };

  const [promoCodeError, setPromoCodeError] = useState("");
  const [promoCode, setPromoCode] = useState("");
  const [isPromoSuccess, setPromoSuccess] = useState(false);
  const [isPromoLoading, setIsPromoLoading] = useState(false);

  const [claimedReward, setClaimedReward] = useState(null);
  
  // Check for stored promo code on component mount
  useEffect(() => {
    const userId = userDetails?.userDetails?.telegramId;
    const storedPromoCode = localStorage.getItem(`promoCode_${userId}`);
    
    if (storedPromoCode) {
      setPromoCode(storedPromoCode);
      // Remove the stored promo code after using it
      localStorage.removeItem(`promoCode_${userId}`);
    }
  }, [userDetails]);
  
  const ClosePromo = () => {
    setPromoSuccess(false);
    setClaimedReward(null);
    setPromoCode("");
  };

  const onChangePromo = (value) => {
    setPromoCode(value);
    if (promoCode) {
      setPromoCodeError("");
    }
  };
  const ClaimButton = async () => {
    playClick();
    if (!promoCode) {
      setPromoCodeError("PLEASE ENTER PROMO CODE!");
      return;
    } else {
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: true,
      }));
      setIsPromoLoading(true);
      const data = {
        promoCode: promoCode,
      };

      try {
        const response = await EarlyRewardClaim(data); // Make the API call
        if (response?.success) {
          setPromoSuccess(true);
          setClaimedReward(response?.data?.claimedReward);
        } else {
          setPromoCodeError(response?.error);
        }
      } catch (error) {
        console.error("Error during API call:", error);
      } finally {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        setIsPromoLoading(false);
      }
    }
  };

  const Xclaimed = xchannelvalid === "claimed" || xchannelvalid == "Isclaimed";
  const Yclaimed = ychannelvalid === "claimed" || ychannelvalid == "Isclaimed";
  const Tclaimed = tchannelvalid === "claimed" || tchannelvalid == "Isclaimed";
  const TOffClaimed =
    tOffChannelvalid === "claimed" || tOffChannelvalid == "Isclaimed";

  const GoToX = () => {
    window.open("https://x.com/thememe_tv", "_blank");
  };
  const GoToY = () => {
    window.open("https://instagram.com/thememe_tv", "_blank");
  };
  const GoToT = () => {
    window.open("https://t.me/thememetvcommunity", "_blank");
  };
  const GoToAnnounceT = () => {
    window.open("https://t.me/thememetvofficial", "_blank");
  };

  // Add new state for create promo popup
  const [createPromoVisible, setCreatePromoVisible] = useState(false);

  // Add handler for opening/closing create promo popup
  const toggleCreatePromo = () => {
    playClick();
    setCreatePromoVisible(!createPromoVisible);
  };

  // Add these new state variables near the top of the component
  const [promoPoints, setPromoPoints] = useState(0);
  const [promoName, setPromoName] = useState("");

  const getSliderBackground = () => {
    const percentage = ((promoPoints - 500) / (10000 - 500)) * 100;
    return `linear-gradient(to right, 
      #09BD1B 0%, 
      #09BD1B ${percentage}%, 
      #2c2c2c ${percentage}%, 
      #2c2c2c 100%)`;
  };

  // Add these new state variables near the top of the component
  const [createPromoSuccess, setCreatePromoSuccess] = useState(false);
  const [createdPromoPoints, setCreatedPromoPoints] = useState(null);
  const [createdPromoCode, setCreatedPromoCode] = useState("");

  // Add this state for error messages
  const [promoError, setPromoError] = useState("");

  const closePromo = () => {
    setCreatePromoSuccess(false); // Hide the promo popup
  };
  // Add this new function
  const handleCreatePromo = async () => {
    playClick();
    setPromoError(""); // Clear any previous errors
    if (promoPoints >= 500) {
      setIsPromoLoading(true);
      try {
        // Call the API to generate the promo code
        const response = await callGeneratePromoCode({
          promoRewardValue: promoPoints,
          category: "userpromo", // You can change this based on your requirements
        });
        console.log(response, "response");

        if (response?.success) {
          setCreatedPromoPoints(promoPoints);
          setCreatedPromoCode(response.data.data.promoCode);
          setCreatePromoSuccess(true);
          setCreatePromoVisible(false);
        } else {
          setPromoError(response?.error || "Failed to create promo code");
        }
      } catch (error) {
        console.error("Error creating promo code:", error);
        setPromoError("An error occurred while creating the promo code");
      } finally {
        setIsPromoLoading(false);
      }
    }
  };

  const callGeneratePromoCode = async (data) => {
    playClick();
    try {
      console.log("Calling GeneratePromoCode with data:", data);
      const response = await GeneratePromoCode(data);
      console.log("GeneratePromoCode response:", response);
      return response;
    } catch (error) {
      console.error("Error in callGeneratePromoCode:", error);
      throw error;
    }
  };

  // Add this state for copy feedback
  const [copied, setCopied] = useState(false);

  // Add this function to handle copy
  const handleCopy = () => {
    const promoText = createdPromoCode;
    navigator.clipboard.writeText(promoText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleShare = () => {
    playClick();
    const url = encodeURIComponent(
      `https://t.me/the_meme_tv_bot?startapp=${createdPromoCode}`
    );
    const text = encodeURIComponent(
      "I just dropped some free tokens for you! 🎁 Use my promo code to claim yours now before it's gone."
    );
    const telegramUrl = `https://t.me/share/url?url=${url}&text=${text}`;

    window.open(telegramUrl, "_blank");
  };

  return (
    <>
      <div className="info-img">
        <img
          onClick={() => {
            toogleMenu();
          }}
          src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
          className="cancel-imgpoints"
          style={{ cursor: "pointer", pointerEvents: "all" }}
        />
        <div
          className="menupointer stuff-body"
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            marginTop: "15%",
            flexDirection: "column",
            pointerEvents: "all",
          }}
        >
          <div>
            <div className="row">
              <div className="col-12">
                <div className="doearn-img">
                  {/* <img className="stuff-gif" src={dobottom} /> */}
                  <div className="earn-img">
                    {/* <img src={earn} /> */}
                    <h2 className="do-earn">Do & Earn</h2>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="promo-scroll"
              style={{
                // paddingBottom:'60px',
                maxHeight: "58vh",
                overflowY: "scroll",
                // padding:'6px',
                // boxSizing: "border-box",
                scrollbarWidth: "none",
              }}
            >
              <div style={{ textAlign: "center", paddingTop: "4px" }}>
                <h6 style={{ color: "#656565" }}>PROMO TOKENS</h6>
              </div>
              <div className="promo-container">
                <div
                  className={`promo-card ${
                    isHelpVisible ? "help-visible" : ""
                  }`}
                >
                  <div className="promo-header">
                    <span
                      className={`promo-title ${
                        isHelpVisible ? "fade-out" : ""
                      }`}
                      style={{ marginTop: "3px" }}
                    >
                      REDEEM TOKENS
                    </span>
                    <button
                      className="toggle-button"
                      onClick={toggleHelp}
                      aria-label={isHelpVisible ? "Close help" : "Show help"}
                    >
                      {isHelpVisible ? (
                        <img
                          alt=""
                          src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                          style={{ width: "16px" }}
                        ></img>
                      ) : (
                        <img
                          src="https://d1ccopf5cw1hft.cloudfront.net/s3data/info.png"
                          alt=""
                          style={{ width: "18px" }}
                        ></img>
                      )}
                    </button>
                  </div>
                  <div
                    className={`promo-content ${
                      isHelpVisible ? "fade-out" : ""
                    }`}
                  >
                    <div className="promo-input-group">
                      <input
                        type="text"
                        value={promoCode}
                        onChange={(e) => onChangePromo(e.target.value)}
                        placeholder="ENTER PROMO-CODE"
                        className="promo-input"
                      />
                      <button
                        onClick={ClaimButton}
                        disabled={isPromoLoading}
                        className="claim-button"
                      >
                        CLAIM
                      </button>
                    </div>
                  </div>
                  <p className={`help-text ${isHelpVisible ? "fade-in" : ""}`}>
                    FIND THE PROMO CODE ON{" "}
                    <span className="highlight-DoEarn">
                      THEMEMETV COMMUNITY{" "}
                    </span>
                    AND REDEEM YOUR POINTS HERE!
                  </p>
                </div>
                <div className="promo-header-container">
                  <h6
                    onClick={toggleCreatePromo}
                    className="promo-title text-uppercase"
                    style={{ color: "#000" }}
                  >
                    Create Promo-code
                  </h6>
                  <div
                    className="history-icon"
                    onClick={() => {
                      updateUserInfo((prev) => ({
                        ...prev,
                        currentComponent: PromoHistory,
                        currentComponentText: "PromoHistory",
                      }));
                    }}
                  >
                    <Timer size={18} color="#000" />
                  </div>
                </div>
              </div>

              <div>
                {promoCodeError && (
                  <h6
                    style={{
                      color: "red",
                      textAlign: "center",
                      paddingTop: "5px",
                    }}
                  >
                    {promoCodeError}
                  </h6>
                )}
                <h6
                  style={{
                    color: "#656565",
                    textAlign: "center",
                    paddingTop: "5px",
                  }}
                >
                  TASK TOKENS
                </h6>
              </div>

              <div>
                <div className="row mt20 cheap-stuff" style={{ width: "100%" }}>
                  <div
                    className="col-2"
                    onClick={() => {
                      if (TOffClaimed) GoToAnnounceT();
                    }}
                  >
                    <img
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/telegram.svg"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="col-7 stuff-text">
                    <h4>JOIN OUR TELEGRAM ANNOUNCEMENT CHANNEL</h4>
                    <p className="stuff-p">
                      <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png" />{" "}
                      +5,000{" "}
                    </p>
                  </div>
                  <div className="col-3">
                    {!tOffchannel && tOffChannelvalid !== "Isclaimed" && (
                      <button
                        onClick={() => {
                          if (!tOffchannel) joinMemeOffChannel();
                        }}
                        className="stuff-go"
                        type="button"
                      >
                        GO
                      </button>
                    )}
                    {tOffchannel &&
                      !tOffChannelvalid &&
                      tOffChannelvalid !== "claimed" &&
                      tOffChannelvalid !== "Isclaimed" && (
                        <button className="validate" type="button">
                          Validating
                        </button>
                      )}
                    {tOffchannel &&
                      tOffChannelvalid &&
                      tOffChannelvalid !== "claimed" &&
                      tOffChannelvalid !== "Isclaimed" && (
                        <button
                          onClick={() => {
                            claimRewards("telegramCommunity");
                          }}
                          className="stuff-claim"
                          type="button"
                        >
                          CLAIM
                        </button>
                      )}
                    {TOffClaimed && (
                      <button className="validate" type="button">
                        CLAIMED
                      </button>
                    )}
                  </div>
                </div>
                <div className="row mt10 cheap-stuff" style={{ width: "100%" }}>
                  <div
                    className="col-2"
                    onClick={() => {
                      if (Xclaimed) GoToX();
                    }}
                  >
                    <img
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/twitter.svg"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="col-7 stuff-text">
                    <h4>FOLLOW US ON X</h4>
                    <p className="stuff-p">
                      <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png" />{" "}
                      +5,000{" "}
                    </p>
                  </div>
                  <div className="col-3">
                    {!xchannel && xchannelvalid !== "Isclaimed" && (
                      <button
                        onClick={() => {
                          if (!xchannel) joinXChannel();
                        }}
                        className="stuff-go"
                        type="button"
                      >
                        GO
                      </button>
                    )}
                    {xchannel &&
                      !xchannelvalid &&
                      xchannelvalid !== "claimed" &&
                      xchannelvalid !== "Isclaimed" && (
                        <button className="validate" type="button">
                          Validating
                        </button>
                      )}
                    {xchannel &&
                      xchannelvalid &&
                      xchannelvalid !== "claimed" &&
                      xchannelvalid !== "Isclaimed" && (
                        <button
                          onClick={() => {
                            claimRewards("twitter");
                          }}
                          className="stuff-claim"
                          type="button"
                        >
                          CLAIM
                        </button>
                      )}
                    {Xclaimed && (
                      <button className="validate" type="button">
                        CLAIMED
                      </button>
                    )}
                  </div>
                </div>

                <div className="row mt10 cheap-stuff" style={{ width: "100%" }}>
                  <div
                    className="col-2"
                    onClick={() => {
                      if (Yclaimed) GoToY();
                    }}
                  >
                    <img
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/youtube.svg"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="col-7 stuff-text">
                    <h4>FOLLOW US ON INSTAGRAM</h4>
                    <p className="stuff-p">
                      <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png" />{" "}
                      +5,000{" "}
                    </p>
                  </div>
                  <div className="col-3">
                    {!ychannel && ychannelvalid !== "Isclaimed" ? (
                      <button
                        onClick={() => {
                          if (!ychannel) joinYChannel();
                        }}
                        className="stuff-go"
                        type="button"
                      >
                        GO
                      </button>
                    ) : null}
                    {ychannel &&
                      ychannelvalid &&
                      ychannelvalid !== "claimed" &&
                      ychannelvalid !== "Isclaimed" && (
                        <button
                          onClick={() => {
                            claimRewards("youtube");
                          }}
                          className="stuff-claim"
                          type="button"
                        >
                          CLAIM
                        </button>
                      )}
                    {Yclaimed && (
                      <button className="validate" type="button">
                        CLAIMED
                      </button>
                    )}
                    {ychannel && !ychannelvalid && (
                      <button className="validate" type="button">
                        Validating
                      </button>
                    )}
                  </div>
                </div>

                <div className="row mt10 cheap-stuff" style={{ width: "100%" }}>
                  <div
                    className="col-2"
                    onClick={() => {
                      if (Tclaimed) GoToT();
                    }}
                  >
                    <img
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/telegram.svg"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="col-7 stuff-text">
                    <h4>JOIN OUR TELEGRAM DICUSSION CHANNEL</h4>
                    <p className="stuff-p">
                      <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png" />{" "}
                      +5,000{" "}
                    </p>
                  </div>
                  <div className="col-3">
                    {!tchannel && tchannelvalid !== "Isclaimed" ? (
                      <button
                        onClick={() => {
                          if (!tchannel) joinTChannel();
                        }}
                        className="stuff-go"
                        type="button"
                      >
                        GO
                      </button>
                    ) : null}
                    {tchannel &&
                      tchannelvalid &&
                      tchannelvalid !== "claimed" &&
                      tchannelvalid !== "Isclaimed" && (
                        <button
                          onClick={() => {
                            claimRewards("telegram");
                          }}
                          className="stuff-claim"
                          type="button"
                        >
                          CLAIM
                        </button>
                      )}
                    {Tclaimed && (
                      <button className="validate" type="button">
                        CLAIMED
                      </button>
                    )}
                    {tchannel && !tchannelvalid && (
                      <button className="validate" type="button">
                        Validating
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isPromoSuccess && (
          <div className="popup1">
            <div className="popup-content1">
              <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/gift.svg" />
              <h2 className="epic1">CONGRATULATIONS!</h2>
              <img
                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                className="cancel-img1"
                onClick={ClosePromo}
              />
              <div className="row text-center">
                <div className="col-12">
                  <div className="epic-div1">
                    {/* Display the correct streak reward */}
                    <h3 className="rw-popup1">
                      <img
                        style={{ width: "25px" }}
                        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png"
                        alt="logo"
                      />{" "}
                      {claimedReward}
                    </h3>
                  </div>
                </div>
              </div>
              <button className="btn-rewardsos" onClick={ClosePromo}>
                DONE
              </button>
            </div>
          </div>
        )}
        {createPromoVisible && (
          <div className="overlay">
            <div className="popup">
              <div className="">
                <h2 className="promo-popup">Create Promo-Code</h2>
                <img
                  src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                  className="cancel-img"
                  onClick={toggleCreatePromo}
                />
                <div className="row text-center">
                  <div className="col-12">
                    <div className="create-promo-container">
                      <div className="points-input-container">
                        <input
                          type="text"
                          value={promoPoints}
                          readOnly
                          className="points-input"
                        />
                      </div>
                      <div className="points-slider-container">
                        <input
                          type="range"
                          min="500"
                          max="10000"
                          step="100"
                          value={promoPoints}
                          onChange={(e) => {
                            const value = parseInt(e.target.value);
                            setPromoPoints(value);
                            e.target.style.background = getSliderBackground();
                          }}
                          style={{ background: getSliderBackground() }}
                          className="points-slider"
                        />
                        <div className="slider-markers">
                          <span>500</span>
                          <span>5000</span>
                          <span>10000</span>
                        </div>
                      </div>
                      <div
                        className="promo-history-link"
                        onClick={() => {
                          /* Add your history view logic here */
                        }}
                      >
                        <div
                          className="history-text"
                          onClick={() => {
                            updateUserInfo((prev) => ({
                              ...prev,
                              currentComponent: PromoHistory,
                              currentComponentText: "PromoHistory",
                            }));
                          }}
                        >
                          <svg
                            className="history-icon"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
                          </svg>
                          Promo Code History
                        </div>
                      </div>
                      <button
                        className="btn-rewardsos mt-3"
                        onClick={handleCreatePromo}
                        disabled={promoPoints < 500 || isPromoLoading}
                      >
                        {isPromoLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            CREATING...
                          </>
                        ) : (
                          "CREATE PROMO CODE"
                        )}
                      </button>
                      {promoError && (
                        <div className="error-message mt-2">{promoError}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {createPromoSuccess && (
          <div className="overlay">
            <div className="popup">
              <div className="">
                <h2 className="promo-popup">Create Promo-Code</h2>
                <img
                  src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                  className="cancel-img"
                  onClick={closePromo}
                />

                <div className="row text-center">
                  <div className="col-12">
                    <div className="">
                      <span className="promo-text">created successfully</span>
                      <input
                        type="text"
                        value={`PROMO CODE = ${createdPromoCode}`}
                        readOnly
                        className="promo-result-input"
                      />
                      <div className="button-group mt-3 mb-3">
                        <button className="btn-share" onClick={handleShare}>
                          <svg
                            className="button-icon"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
                          </svg>
                          Share
                        </button>
                        <button className="btn-copy" onClick={handleCopy}>
                          <svg
                            className="button-icon"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M16 1H4C2.9 1 2 1.9 2 3v14h2V3h12V1zm3 4H8C6.9 5 6 5.9 6 7v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
                          </svg>
                          {copied ? "Copied!" : "Copy"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <style>
        {`
          .promo-header-container {
               display: flex;
    justify-content: space-between;
    padding: 5px 10px;
    /* color: azure; */
    background: #09BD1B;
    margin: 0px 10px;
    border-radius: 0px 0px 5px 5px;
            
          }
          .promo-title {
            margin-bottom: 0px;
            color: aliceblue;
            padding: 7px 0px;
          }
          .history-icon {
            cursor: pointer;
            color: #000;
          }

          .history-icon:hover {
            color: #000;
          }

          .create-promo-container {
            padding: 14px;
            // display: flex;
            flex-direction: column;
            gap: 20px;
          }

          .points-slider-container {
            display: flex;
            flex-direction: column;
            gap: 5px;
            padding: 10px 0;
            position: relative;
          }

          .points-slider {
            width: 100%;
            height: 8px;
            -webkit-appearance: none;
            background: ${getSliderBackground()};
            // border-radius: 4px;
            outline: none;
            opacity: 1;
            transition: all .2s ease;
          }

          .points-slider::-webkit-slider-runnable-track {
            width: 100%;
            height: 8px;
            cursor: pointer;
            border-radius: 4px;
          }

          .points-slider::-moz-range-track {
            width: 100%;
            height: 8px;
            cursor: pointer;
            border-radius: 4px;
          }

          .points-slider::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 30px;
            height: 20px;
            background: #237E17;
            cursor: pointer;
            box-shadow: 0 0 5px rgba(0,0,0,0.5);
            margin-top: -8px;
            position: relative;
            z-index: 2;
            /* Add horizontal lines using pseudo-elements */
            background-image: linear-gradient(90deg, #03C216, #03C216),
                             linear-gradient(90deg, #03C216, #03C216),
                             linear-gradient(90deg, #03C216, #03C216);
            background-size: 2px 8px;
            background-position: calc(50% - 4px) center,
                        50% center,
                        calc(50% + 4px) center;
            background-repeat: no-repeat;
          }

          .points-slider::-moz-range-thumb {
            width: 30px;
            height: 20px;
            background: #237E17;
            cursor: pointer;
            box-shadow: 0 0 5px rgba(0,0,0,0.5);
            position: relative;
            z-index: 2;
            /* Add horizontal lines using pseudo-elements */
            background-image: linear-gradient(90deg, #03C216, #03C216),
                             linear-gradient(90deg, #03C216, #03C216),
                             linear-gradient(90deg, #03C216, #03C216);
            background-size: 2px 8px;
            background-position: calc(50% - 5px) center,
                        50% center,
                        calc(50% + 4px) center;
            background-repeat: no-repeat;
          }

          .slider-markers {
            display: flex;
            justify-content: space-between;
            padding: 0 2px;
            color: #fff;
            font-size: 12px;
            margin-top: 5px;
          }

          .slider-markers span {
            position: relative;
            text-align: center;
          }

          .slider-markers span:before {
            content: '';
            position: absolute;
            top: -18px;
            width: 2px;
            height: 8px;
            background: #247e17;
          }

          .slider-markers span:first-child:before {
            left: 0;
            right: auto;
            transform: translateX(0);
          }

          .slider-markers span:last-child:before {
            right: 0;
            left: auto;
            transform: translateX(0);
          }

          .slider-markers span:nth-child(2):before {
            left: 50%;
            transform: translateX(-50%);
          }

          .points-slider:hover {
            opacity: 1;
          }

          .mb-3 {
            margin-bottom: 15px;
          }

          .mt-3 {
            margin-top: 15px;
          }

          .btn-rewardsos {
            background: #237E17;
            color: white;
            border: 1px solid #4CF038;
            padding: 10px 20px;
            border-radius: 2px;
            cursor: pointer;
            width: 100%;
            transition: background 0.3s;
          }

          .btn-rewardsos:disabled {
            background: #666;
            cursor: not-allowed;
            opacity: 0.7;
            border: 1px solid #868686;
          }

          .btn-rewardsos:not(:disabled):hover {
            background: #1a5f11;
          }

          .points-input-container {
            position: relative;
            margin-bottom: 15px;
          }

          .points-input-container .coin-icon {
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
            width: 20px;
            height: 20px;
          }

          .points-input {
            width: 100%;
            padding: 10px;
            border: 1px solid #6F6F6F;
            border-radius: 2px;
            font-size: 16px;
            color: #237E17;
            background: #1B1B1B;
          }

          .points-input:read-only {
            cursor: default;
          }
            .promo-text
            {
                color: #5b5b5b;
    text-transform: uppercase;
    font-size: 13px;
            }

          .promo-result-input {
               width: 100%;
    padding: 12px 15px;
    border: 1px dashed #515151;
    border-radius: 0px;
    font-size: 16px;
    text-align: center;
    color: #ffffff;
    background: #151515;
    margin-top: 15px;
    margin-bottom: 15px;
    letter-spacing: 1px;
          }

          .button-group {
            display: flex;
            gap: 10px;
            justify-content: center;
            margin-top: 15px;
          }

          .btn-copy, .btn-share {
            padding: 10px;
            border-radius: 2px;
            cursor: pointer;
            transition: all 0.3s;
            display: flex;
            width: 45%;
            text-transform: uppercase;
            align-items: center;
            gap: 8px;
            justify-content: center;
          }

          .button-icon {
            width: 18px;
            height: 18px;
          }

          .btn-copy {
            background: #034807;
            color: #4CF038;
            border: 1px solid #4CF038;
          }

          .btn-share {
            background:rgb(12, 22, 12);
            color: #4CF038;
            border: 1px solid #4CF038;
          }

          .btn-copy:hover, .btn-share:hover {
            opacity: 0.9;
            transform: translateY(-1px);
          }

          .promo-history-link {
            margin-top: 15px;
            cursor: pointer;
            padding: 8px;
            color:#ffffff;
            text-transform: uppercase;
          }

          .history-text {
            color: #ffffff;
            font-size: 14px;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 6px;
            justify-content: center;
          }

          .history-icon {
            width: 20px;
            height: 20px;
            color: #000;
          }

          .history-text:hover {
            opacity: 0.8;
          }
          
          .error-message {
            color: #ff4d4d;
            font-size: 14px;
            text-align: center;
            margin-top: 10px;
            padding: 5px;
            background-color: rgba(255, 77, 77, 0.1);
            border-radius: 4px;
          }
        `}
      </style>
    </>
  );
};

export default DoEarn;
